import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./bays.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./bays.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { BaysConstants, BaysHeadingEnumHeadingLookup } from "./bays.constants";
import { BehaviorSubject } from "rxjs";
import { SharedConstants } from "../../shared/constants/shared.constants";
import { AppControllerService } from "../../app-controller.service";
import { SearchContainerHeight } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SaveSearchService } from "../../shared/services/save-search/save-search.service";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import _ from "underscore";
import { TableSearchComponent } from "../../shared/components/table-search/table-search.component";
import { BaySearchEnum, BaySearchOption } from "./shared/Enums/bay-search-enum";
import { SearchTableService } from "../../shared/services/table-column-mapping/search-table.service";
import { MapServiceService } from "../../core/settings/shared/map-service.service";
import { BaySearchService } from "./shared/services/bay-search.service";
import { BaysSearchColumnToArcGisColumnBaysLookup } from "./shared/models/bay-search-to-arcgis.model";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { AlertType } from "../../shared/models/alert";
import { Store } from "@ngrx/store";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { baysSearch } from "../../store/actions/tab-bays.actions";
let BaysComponent = class BaysComponent {
    appControllerService;
    baySearchService;
    moduleConfigService;
    changeDetectorRef;
    saveSearchService;
    searchTableService;
    mapService;
    requestStatusService;
    store;
    tableSearchFilterComponent;
    pageHeading = BaysConstants.Headings.PageHeadings;
    showSearchButton = true;
    bayAttributeToTableColumn;
    filterOptions;
    selectedBaySubject = new BehaviorSubject(undefined);
    selectedBay;
    placeHolder;
    searchPlaceHolder;
    baySearchTableDataSource;
    isMapLoaded = false;
    parentComponentRef = "BaysComponent";
    preSelected;
    mapComponent;
    bayList = [];
    setMapLayerSubscription;
    constructor(appControllerService, baySearchService, moduleConfigService, changeDetectorRef, saveSearchService, searchTableService, mapService, requestStatusService, store) {
        this.appControllerService = appControllerService;
        this.baySearchService = baySearchService;
        this.moduleConfigService = moduleConfigService;
        this.changeDetectorRef = changeDetectorRef;
        this.saveSearchService = saveSearchService;
        this.searchTableService = searchTableService;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.store = store;
        this.initializeColumnToObjectMapping();
    }
    ngOnInit() {
        this.initializeConstants();
        this.finaliseMapSettings();
    }
    ngOnDestroy() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.bayList = [];
        this.baySearchService.clearBaysList();
        this.baySearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.changeDetectorRef.detectChanges();
    }
    setMapLayer() {
        this.setMapLayerSubscription = this.mapService.layerUrlListAsObservable.subscribe((layers) => {
            if (layers) {
                this.baySearchService.clearURLList();
                layers.forEach((layer) => {
                    if (layer.moduleId === Number(this.appControllerService.selectedModuleID) && layer.layerType === BaySearchOption.Bay) {
                        this.baySearchService.setURL(layer.layerType, layer.url);
                    }
                });
                this.setBaySearchOptions();
            }
        });
    }
    handleAdvancedSearch() {
    }
    setHeadings() {
        switch (this.baySearchService.baySearchType) {
            case BaySearchOption.Bay:
                this.bayAttributeToTableColumn = BaysHeadingEnumHeadingLookup;
                break;
        }
        this.baySearchService.setTableColumnMap(this.bayAttributeToTableColumn);
        this.setFilterOptions();
        this.changeDetectorRef.detectChanges();
    }
    mapLoaded() {
        this.isMapLoaded = true;
    }
    baySelected($event) {
        this.selectedBaySubject.next($event);
    }
    async handleSimpleSearch(search) {
        await this.searchBays(search);
    }
    async doBaySearch(url, searchText, column) {
        this.requestStatusService.showBusySpinner(SharedConstants.BAY_SEARCH_STATUS);
        // @ts-ignore
        try {
            // @ts-ignore
            await this.baySearchService.doSearch(url, searchText, column, false)
                .then((baysFound) => {
                if (baysFound.length > 0) {
                    this.baySearchService.addMapLocatorLinks(baysFound);
                    this.changeDetectorRef.detectChanges();
                }
                else {
                    this.appControllerService.showMessage(`${SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE} that matches your search term`, AlertType.Warning);
                }
                this.requestStatusService.removeBusySpinner(SharedConstants.BAY_SEARCH_STATUS);
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner(SharedConstants.BAY_SEARCH_STATUS);
        }
    }
    finaliseMapSettings() {
        this.searchPlaceHolder = `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`;
        this.setMapLayer();
        this.showMap(false);
    }
    setFilterOptions() {
        this.filterOptions = new Array();
        this.filterOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterOptions.push(..._.values(this.bayAttributeToTableColumn.values()));
        this.changeDetectorRef.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.bayAttributeToTableColumn = BaysHeadingEnumHeadingLookup;
    }
    setBaySearchOptions() {
        const searchOptionList = [];
        if (this.moduleConfigService.isInformalTradeModule() && this.baySearchService.bayUrl && this.baySearchService.bayUrl !== "") {
            searchOptionList.push(..._.values(BaySearchEnum));
        }
        const bayOptions = [];
        searchOptionList.forEach((option) => {
            if (bayOptions.indexOf(option) < 0) {
                bayOptions.push(option);
            }
        });
        this.searchTableService.setPropertySearchOptions(bayOptions);
        this.baySearchService.setSearchOptionLookup(BaySearchEnum);
        this.preSelected = bayOptions[0];
        this.baySearchService.setSelectedSearchOption(this.preSelected);
        this.searchTableService.setPreSelectedSearchOption(this.preSelected);
        this.selectedBay = this.selectedBaySubject.asObservable();
        this.setHeadings();
    }
    showMap(displayMap) {
        if (displayMap) {
            this.isMapLoaded = true;
        }
        else {
            this.isMapLoaded = false;
        }
    }
    async searchBays(search) {
        if (search.column !== SharedConstants.SEARCH_BY_DEFAULT) {
            // @ts-ignore
            const column = this.getArcGISColumn(search.column);
            const url = this.baySearchService.getLayerUrl(this.baySearchService.baySearchType);
            // @ts-ignore
            this.baySearchTableDataSource = await this.doBaySearch(url, search.text, column);
            this.store.dispatch(baysSearch({ value: this.baySearchTableDataSource }));
            this.changeDetectorRef.detectChanges();
        }
    }
    getArcGISColumn(column) {
        this.baySearchService.setSelectedSearchOption(column);
        this.setHeadings();
        switch (this.baySearchService.baySearchType) {
            case BaySearchOption.Bay:
                return BaysSearchColumnToArcGisColumnBaysLookup.get(column);
        }
    }
    initializeConstants() {
        this.initializePageHeader();
        this.initializeSearchTableConstants();
        this.baySearchService.clearBaysList();
        this.baySearchService.clearTableColumnMap();
        this.baySearchService.setTableColumnMap(BaysHeadingEnumHeadingLookup);
    }
    initializePageHeader() {
        this.pageHeading = BaysConstants.Headings.PageHeadings;
    }
    initializeSearchTableConstants() {
        this.placeHolder = SharedConstants.SEARCH_BY_DEFAULT;
        this.bayList = [];
        this.baySearchService.clearBaysList();
        this.baySearchTableDataSource = null;
        this.saveSearchService.clearSavedSearchResults();
        this.searchTableService.changeContainerHeight(SearchContainerHeight.Bays);
        this.bayAttributeToTableColumn = BaysHeadingEnumHeadingLookup;
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: BaySearchService },
        { type: ModuleConfigService },
        { type: ChangeDetectorRef },
        { type: SaveSearchService },
        { type: SearchTableService },
        { type: MapServiceService },
        { type: RequestStatusService },
        { type: Store }
    ];
    static propDecorators = {
        tableSearchFilterComponent: [{ type: ViewChild, args: [TableSearchComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["baysMap", { static: true },] }]
    };
};
BaysComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-bays",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], BaysComponent);
export { BaysComponent };
